import { ChatGroupSearchSchema, DataIdSchema } from "@/schemas";
import {
	Outlet,
	createFileRoute,
	retainSearchParams,
} from "@tanstack/react-router";
import { zodSearchValidator } from "@tanstack/router-zod-adapter";
import { getContactPeopleLoader } from "../../-funtions/loader/direct";

export const Route = createFileRoute("/dashboard/chat/single/$id")({
	params: {
		parse: (params) => ({
			id: DataIdSchema.parse(Number(params.id)),
		}),
		stringify: ({ id }) => ({ id: id.toString() }),
	},
	validateSearch: zodSearchValidator(ChatGroupSearchSchema),
	search: {
		middlewares: [retainSearchParams(["tab"])],
	},
	loader: (ctx) => getContactPeopleLoader(ctx.context, ctx.params.id),
	component: RouteComponent,
});

function RouteComponent() {
	return <Outlet />;
}
